import React from 'react';
// import Header from './header'
// import intro from '../../components/images/intro.png'
// import '../app/App.css'

const About = () => (  
      <>
        <h1 id="aboutme">About Katilyn</h1>
        <article>Hi! I'm Katilyn, a Full Stack Software Engineer passionate about developing tech for everyone. I find joy in systematically evaluating and strategizing creative solutions for life’s little (or big) problems. </article>
        <br></br>
        <article>My history as an International Tour Manager in the Music Industry has developed my grit, drive, and tenacity while honing my ability to work calmly under pressure and produce meaningful results.</article>
        {/* <br></br> */}
        {/* <article>More about my adventures on the road</article>
        <br></br> */}
        {/* <article>Want the tl;dr version? <a alt="resume" href="./">resume</a></article> */}
      </>       
    );

export default About;
